export const acceptance = {
  acceptanceResult: '验收结果',
  acceptanceNotPassed: '验收未通过',
  acceptancePassed: '验收通过',
  acceptancePerson: '验收人',
  acceptanceTime: '验收时间',
  acceptanceDescription: '验收说明',
  completionDetails: '完成详情'
};
